/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var A;!function(A){A[A.TRANSLATE_Z=0]="TRANSLATE_Z",A[A.TRANSLATE_XY=1]="TRANSLATE_XY",A[A.SCALE=2]="SCALE",A[A.ROTATE=3]="ROTATE",A[A.SCALE_ROTATE=4]="SCALE_ROTATE"}(A||(A={}));export{A as ManipulatorType};
